export default {
  default: {
    title: 'Widget ikke funnet',
    description:
      'Widgeten ble ikke funnet i widget-samlingen. Ser ut som en av utviklerne våre har drukket litt for mye mjød. Vi fikser det snart...',
    header: 'Obs...'
  },
  nextSteps: {
    title: 'Neste steg',
    description: 'Her er de neste 5 stegene for alle batcher',
    header: 'Kommende steg'
  },
  calendar: {
    title: 'Kalender',
    description: 'Kalender',
    header: 'Kalender'
  },
  batchOverview: {
    title: 'Batchoversikt',
    description: 'Oversikt over aktive og planlagte batcher',
    header: 'Batchoversikt',
    startBrewing: 'Start brygging',
    active: 'Aktive',
    planned: 'Planlagte',
    noBrews: 'Ingen brygg'
  },
  tilts: {
    title: 'Tilts',
    description: 'Tilt-avlesninger',
    header: 'Tilts'
  },
  ispindels: {
    title: 'iSpindels',
    description: 'iSpindel-avlesninger',
    header: 'iSpindels'
  },
  board: {
    empty: 'Ingen metrikk tilgjengelig',
    itemDefaultHeader: 'Tavleelement tittel',
    itemDefaultContent: 'Tavleelement innhold'
  }
};
